var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4,
    width: 12,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1C10.3244 1 8.19767 1.64514 6.38873 2.85383C4.57979 4.06253 3.16989 5.78049 2.33733 7.79048C1.50477 9.80047 1.28693 12.0122 1.71137 14.146C2.1358 16.2798 3.18345 18.2398 4.72183 19.7782C6.26021 21.3165 8.22022 22.3642 10.354 22.7886C12.4878 23.2131 14.6995 22.9952 16.7095 22.1627C18.7195 21.3301 20.4375 19.9202 21.6462 18.1113C22.8549 16.3023 23.5 14.1756 23.5 12C23.5 9.08262 22.3411 6.28472 20.2782 4.22182C18.2153 2.15892 15.4174 1 12.5 1ZM10.9286 16.3928L7 12.4642L8.24976 11.2143L10.9286 13.8929L16.7507 8.07143L18.0045 9.31749L10.9286 16.3928Z",
    fill: "#198038"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess);
export default __webpack_public_path__ + "static/media/ic-success.3cf691d149644fda7d4d287acc51c3ca.svg";
export { ForwardRef as ReactComponent };